import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeftSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronLeftSmall"><Path d="M14 16L10 12L14 8" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronLeftSmall;
